// The store name field as it is typed: lowercase letters, digits and single
// hyphens, no leading hyphen. A trailing hyphen stays so "radha-" can become
// "radha-krishna"; the signup form refuses one that is still there on submit.
export const typedStoreName = (value) => String(value || "")
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-{2,}/g, "-")
    .replace(/^-+/, "");
